import * as React from 'react';

import { Access } from './parts/access';
import { StandardPage } from './parts/standardPage';
import { HomeLocationManagement } from '../containers/homeLocations';

export function HomeLocationManagementRoute() {
  return (
    <Access role="manager">
      <StandardPage>
        <HomeLocationManagement />
      </StandardPage>
    </Access>
  );
}
